import React from "react";
import { motion } from "framer-motion";
import { Landmark } from "lucide-react";
import { useLang } from "@/contexts/LangContext";

const COPY = {
  en: {
    kicker: "Grounded in Lebanese law",
    laws: ["Labour Code", "Code of Commerce", "Tax Procedures Law", "Social Security (NSSF) Law", "Code of Obligations and Contracts"],
  },
  fr: {
    kicker: "Fondé sur le droit libanais",
    laws: ["Code du travail", "Code de commerce", "Loi sur les procédures fiscales", "Loi sur la sécurité sociale (CNSS)", "Code des obligations et des contrats"],
  },
  ar: {
    kicker: "مستند إلى القانون اللبناني",
    laws: ["قانون العمل", "قانون التجارة", "قانون الإجراءات الضريبية", "قانون الضمان الاجتماعي", "قانون الموجبات والعقود"],
  },
};

export const LawsStrip = () => {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <section className="border-t border-[#E9ECEF] bg-white" data-testid="laws-strip">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
        <div className="flex items-center gap-3 shrink-0">
          <Landmark className="w-5 h-5 text-[#C65D47]" />
          <span className="text-xs tracking-[0.24em] uppercase font-bold text-[#868E96]">{c.kicker}</span>
        </div>
        <ul className="flex flex-wrap gap-x-8 gap-y-3">
          {c.laws.map((law, i) => (
            <motion.li
              key={law}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="flex items-center gap-3 font-display text-lg md:text-xl text-[#0A1128]"
              data-testid={`laws-strip-item-${i}`}
            >
              <span className="inline-block w-1.5 h-1.5 bg-[#C65D47]" />
              {law}
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};
